import { LoaderContext } from 'contexts/loader-context'
import type React from 'react'
import { useState, useRef, useEffect, useContext } from 'react'
import LoaderPopup from './loaderInternalPopup'

interface SlideUpPopupProps {
  isOpen: boolean
  onClose: () => void
  children: React.ReactNode
}

const SlideUpPopup: React.FC<SlideUpPopupProps> = ({ isOpen, onClose, children }) => {
  const [startY, setStartY] = useState(0)
  const [currentY, setCurrentY] = useState(0)
  const [isDragging, setIsDragging] = useState(false)
  const [isVisible, setIsVisible] = useState(false) // Estado para controlar la visibilidad
  const popupRef = useRef<HTMLDivElement>(null)
  const { loadPopup } = useContext(LoaderContext)
  useEffect(() => {
    // const handleClickOutside = (event: MouseEvent) => {
    //   if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
    //     onClose()
    //   }
    // }

    if (isOpen) {
      // document.addEventListener('mousedown', handleClickOutside)
      document.body.classList.add('no-scroll')

      setTimeout(() => {
        setIsVisible(true)
      }, 10)
    } else {
      setIsVisible(false)
      document.body.classList.remove('no-scroll')
    }

    return () => {
      // document.removeEventListener('mousedown', handleClickOutside)
      document.body.classList.remove('no-scroll')
    }
  }, [isOpen, onClose])

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    setStartY(e.touches[0].clientY)
    setIsDragging(true)
  }

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    if (isDragging) {
      setCurrentY(e.touches[0].clientY)
    }
  }

  const handleTouchEnd = () => {
    if (currentY - startY > 50) {
      onClose()
    }
    setIsDragging(false)
    setCurrentY(0)
    setStartY(0)
  }

  if (!isOpen) return null

  const dragOffset = isDragging ? Math.max(0, currentY - startY) : 0

  return (
    <div className={`slide-up-popup ${isVisible ? 'open' : ''} lg:py-6 transform transition-transform`}>
      <div
        ref={popupRef}
        className="slide-up-popup__content"
        style={{
          transform: `translateY(${dragOffset}px)`,
          transition: isDragging ? 'none' : 'transform 0.3s ease-out'
        }}
      >
        {loadPopup && < LoaderPopup />}
        <div
          className="w-full h-10 flex justify-center items-center px-3"
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          <div className="flex justify-center items-center invisible h-full">
            <button className="text-white">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div className="w-12 h-1 rounded-full mx-auto bar sm:invisible" />
          <div className="flex justify-center items-center h-full">
            <button onClick={onClose} className="text-white">
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        <div className="p-3 px-6 overflow-y-auto" style={{ maxHeight: 'calc(calc(var(--vh, 1vh) * 100) - 15vh)' }}>{children}</div>
      </div>
    </div>
  )
}

export default SlideUpPopup
